import {Field, Formik} from 'formik';
import * as React from 'react';
import {Link} from 'react-router-dom';
import * as Yup from 'yup';
import {Button} from '~/components/Button';
import {InputType} from '~/components/Controls/Input';
import {Form, InputField, IntentText, onSubmitError} from '~/components/Form';
import {InfoWrapper} from '~/components/Layout';
import {Intent} from '~/lib/intent';
import {useSession} from '~/modules/Profile/session';
import style from './../index.module.scss';

interface ISignInParams {
    email: string;
    password: string;
}

const SignInSchema = Yup.object().shape<ISignInParams>({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().required('Required')
});

const SignInParamsDefault: ISignInParams = {
    email: '',
    password: ''
};

export const SignInView = () => {
    let {signIn} = useSession();

    return <InfoWrapper links={[
        <Link key='recovery' to='/recovery/request'>Recovery password</Link>
    ]}
    >
        <Formik
            initialValues={SignInParamsDefault}
            validationSchema={SignInSchema}
            onSubmit={(values, actions) => signIn(values.email, values.password).catch(onSubmitError(actions))}
        >
            {(form) => <Form>
                <div className={style.formSimple}>
                    {form.status &&
                        <IntentText intent={Intent.DANGER} className={style.formStatus}>{form.status}</IntentText>}
                    <Field name='email'
                        label='Email'
                        type='text'
                        className={style.simpleField}
                        options={{
                            placeholder: 'Email',
                            type: InputType.EMAIL,
                            disabled: form.isSubmitting,
                            autoComplete: 'email'
                        }}
                        component={InputField}
                    />
                    <Field name='password'
                        label='Password'
                        type='password'
                        className={style.simpleField}
                        options={{
                            placeholder: 'Password',
                            type: InputType.PASSWORD,
                            passwordToggle: true,
                            disabled: form.isSubmitting,
                            autoComplete: 'current-password',
                        }}
                        component={InputField}
                    />
                </div>
                <div>
                    <Button type='submit'
                        disabled={form.isSubmitting}
                        intent={Intent.PRIMARY}
                        rightIcon={form.isSubmitting && <i className='fa fa-spinner fa-spin'/>}
                    >Sign In</Button>
                </div>
            </Form>}
        </Formik>
    </InfoWrapper>;
};
